import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useTheme, SCHEMES } from '../context/ThemeContext';

export default function SettingsDisplay() {
  const { dark, setDark, scheme, setScheme, schemes } = useTheme();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-semibold text-foreground tracking-tight leading-none">Display</h1>
      </div>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Display Settings</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <div className="text-sm font-medium">Appearance</div>
            <div className="flex gap-2">
              <Button variant={dark ? 'default' : 'outline'} onClick={() => setDark(true)}>Dark</Button>
              <Button variant={!dark ? 'default' : 'outline'} onClick={() => setDark(false)}>Light</Button>
            </div>
          </div>

          <div className="space-y-2">
            <div className="text-sm font-medium">Accent palette</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {schemes.map((s) => {
                const sw = SCHEMES[s];
                const active = scheme === s;
                return (
                  <button
                    key={s}
                    type="button"
                    onClick={() => setScheme(s)}
                    className={`flex items-center gap-2 px-3 py-2 rounded-md border text-sm transition-colors ${
                      active
                        ? 'border-primary bg-accent text-accent-foreground'
                        : 'border-border bg-card hover:bg-accent/40'
                    }`}
                  >
                    <span
                      className="inline-block h-3.5 w-3.5 rounded-full ring-1 ring-border"
                      style={{ backgroundColor: `hsl(${sw?.primary})` }}
                    />
                    <span className="flex-1 text-left">{sw?.label || s}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="pt-2">
            <div className="text-sm font-medium mb-2">Preview</div>
            <div className="flex gap-3">
              <Button>Primary Button</Button>
              <Button variant="secondary">Secondary</Button>
              <Button variant="outline">Outline</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
